import { defineStore } from 'pinia';

export type ModalOptions = {
    title: string;
    message: string;
    variant: 'info' | 'success' | 'error';
    confirmLabel?: string;
};

export const useModalStore = defineStore('modals', () => {
    const modalStack = ref<Map<string, ModalOptions | undefined>>(new Map());

    const anyModalsOpen = () => modalStack.value.size > 0;
    const openModal = (modalName: string, options?: ModalOptions) => {
        modalStack.value.set(modalName, options);
    };

    const closeTopModal = () => {
        modalStack.value.delete(topModal.value);
    };

    const isTopModal = (modalName: string) =>
        modalStack.value.size > 0 && topModal.value === modalName;
    const isVisible = (modalName: string) => modalStack.value.has(modalName);
    const getModalOptions = (modalName: string) => modalStack.value.get(modalName);

    const topModal = computed(() => {
        const keys = Array.from(modalStack.value.keys());
        return keys[keys.length - 1];
    });

    return {
        anyModalsOpen,
        closeTopModal,
        getModalOptions,
        isTopModal,
        isVisible,
        modalStack,
        openModal,
        topModal,
    };
});
